
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11209_5654)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_11209_5654)"}},[_c('circle',{attrs:{"cx":"10","cy":"10","r":"10","fill":"#EA2D3F"}}),_c('path',{attrs:{"d":"M5.83 6.105l-1.839.502a.836.836 0 00-.614.806c0 5.17 4.191 9.36 9.36 9.36.376 0 .707-.25.807-.614l.501-1.838a.834.834 0 00-.485-.99l-2.005-.837a.84.84 0 00-.97.243l-.844 1.028a7.035 7.035 0 01-3.355-3.356l1.032-.844a.84.84 0 00.242-.97L6.824 6.59a.836.836 0 00-.99-.485H5.83z","fill":"#fff"}})]),_c('path',{attrs:{"d":"M10.368 6.059a.295.295 0 01.418 0l3.155 3.155.038.046a.296.296 0 01-.41.41l-.046-.038-3.155-3.155a.295.295 0 010-.418z","fill":"#fff","stroke":"#fff","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13.523 6.059a.295.295 0 11.418.418l-3.155 3.155a.295.295 0 11-.418-.418l3.155-3.155z","fill":"#fff","stroke":"#fff","stroke-width":".5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11209_5654"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_11209_5654"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    